import { Account } from "../modules/accounts";
import { Payee } from "../modules/payees";

export type Transaction = {
    medium: TransactionMedium
    payee: Payee
    source: Account
    amount: number
    complete: boolean
  }
  
export enum TransactionMedium {
    Internal = "INTERNAL",
    BillpayMail = "BILLPAY_MAIL",
    BillpayElectronic = "BILLPAY_ELEC",
    BalanceTransfer = "BALANCE_TRANSFER",
    ACH = "ACH",
    Wire = "WIRE",
    InternationalWire = "INTL_WIRE",
    Check = "CHECK"
}